import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEventsList } from '../../../../../app/store/slices/event/event';
import { EVENT_STATUS } from '../../../../../app/store/constant';

export default function useMyEvents() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const { userEvents } = useSelector((state) => state.event);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('all');

    useEffect(() => {
        async function fetchUserEvents() {
            // Fetch user events only if user is logged in and no events are loaded
            // This prevents unnecessary API calls on every render
            if (user?.id && (!userEvents?.data)) {
                setLoading(true);
                try {
                    await dispatch(getEventsList()).unwrap();
                } catch (error) {
                    console.error('Failed to fetch user events:', error);
                } finally {
                    setLoading(false);
                }
            }
        }
        fetchUserEvents();
    }, [user?.id, userEvents?.data]);

    // Filter logic for search and event status
    const filteredEvents = useMemo(() => {
        let events = userEvents?.data || [];

        // Filter by search
        if (searchTerm) {
            events = events.filter((event) =>
                event?.title?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by status
        if (selectedFilter !== 'all') {
            events = events.filter(
                (event) => event?.status?.toLowerCase() === selectedFilter.toLowerCase()
            );
        }

        return events;
    }, [userEvents, searchTerm, selectedFilter]);

    return {
        userEvents,
        loading,
        filterOptions,
        setSearchTerm,
        filteredEvents,
        setSelectedFilter
    };
}

// Filter options to filter event list
const filterOptions = [
    { value: EVENT_STATUS.live, label: 'Live' },
    { value: EVENT_STATUS.scheduled, label: 'Scheduled' },
    { value: EVENT_STATUS.drafted, label: 'Drafted' },
    { value: EVENT_STATUS.ended, label: 'Ended' },
    { value: EVENT_STATUS.cancelled, label: 'Cancelled' },
    { value: 'all', label: 'All Events' }
];
